<template>
  <div>
    <el-button type="primary"
      icon="el-icon-plus"
      @click="createCertificate">新建证书</el-button>
    <certificate-modal ref="modal"
      :vendorId="userInfo.orgId"
      :fetch="fetchList" />
  </div>
</template>
<script>
import CertificateModal from '../certificate-modal.vue'
import { mapState } from 'vuex'
export default {
  name: 'create-certificate-btn',
  components: { CertificateModal },
  props: {
    fetch: Function
  },
  computed: {
    ...mapState({
      userPermission: state => state.account.permission,
      userInfo: state => state.account.userInfo
    })
  },
  methods: {
    createCertificate () {
      const orgId = this.userInfo.orgId
      const prop = this.userPermission.ENT ? 'vendorId' : 'regulatorId'
      this.$refs.modal.init({ [prop]: orgId })
    },
    fetchList () {
      this.fetch && this.fetch()
    }
  }
}
</script>
